/** Déballe les réponses enveloppées par l'intercepteur API sans perdre le type. */
export const unwrapApiData = <T>(payload: T | { data: T }): T => {
  if (typeof payload === 'object' && payload !== null && 'data' in payload) {
    return payload.data;
  }

  return payload;
};
